export default __webpack_public_path__ + "static/media/cart.05dfd14f.svg";